import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      height: '100vh',
      width: '100%',
      maxWidth: 700,
      paddingTop: 100,
      [theme.breakpoints.up('md')]: {
        paddingTop: 150,
      },
    },
    title: {
      margin: `${MIDDLE_MARGIN}px 0`,
      fontSize: 36,
      fontWeight: 700,
      [theme.breakpoints.up('md')]: {
        fontSize: 50,
      },
    },
    link: {
      color: colorsPalette.primary,
    },
    text: {
      fontSize: 16,
      color: colorsPalette.gray,
      '&:not(:last-child)': {
        marginBottom: SMALL_MARGIN,
      },
    },
    img: {
      width: '100%',
      objectFit: 'contain',
    },
  }),
);

export default useStyles;
